import { render, staticRenderFns } from "./selectStaff.vue?vue&type=template&id=2e2e687f&scoped=true"
import script from "./selectStaff.vue?vue&type=script&lang=js"
export * from "./selectStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e687f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2e687f')) {
      api.createRecord('2e2e687f', component.options)
    } else {
      api.reload('2e2e687f', component.options)
    }
    module.hot.accept("./selectStaff.vue?vue&type=template&id=2e2e687f&scoped=true", function () {
      api.rerender('2e2e687f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/customerPointsManagement/dialogs/selectStaff.vue"
export default component.exports